import type { MessagesWithAds } from '@/components/chat'

interface AdsCardProps {
  msg: MessagesWithAds | null
}
const NormalAds = ({ msg }: AdsCardProps) => {
  return (
    <div className='flex justify-center relative left-[-16px] w-[calc(100%+32px)]'>
      <div className='w-full max-w-[100%] bg-white text-gray-800 border  text-sm leading-relaxed whitespace-pre-wrap break-words'>
        <a
          href={msg?.redirect_url}
          target='_blank'
          rel='noopener noreferrer'
          className='text-blue-500 hover:underline'
        >
          <img
            src={msg?.ad_image}
            alt={msg?.company_name ?? ''}
            className='h-[52px] w-full object-contain block'
          />
        </a>
        {/* <p className="mt-1">{msg?.company_name}</p> */}
      </div>
    </div>
  )
}

export default NormalAds
